var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDeliveryMethod = function SvgDeliveryMethod(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 8v12h16V8M4 8l1-4h5M4 8h5m11 0-1-4h-5m6 4h-5m-5-4L9 8m1-4h4M9 8h6M9 8v4l2.051-.684a3.001 3.001 0 0 1 1.898 0L15 12V8m-1-4 1 4",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
};
export default SvgDeliveryMethod;